import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { FaEdit } from "react-icons/fa";
import axios from "axios";

function PopupModal() {
  const [open, setOpen] = useState(false);
  const [paragraph, setParagraph] = useState("");
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [popupId, setPopupId] = useState();  // Store the popup's _id

  // Fetch content from the server
  const fetchContent = async () => {
    try {
      const res = await axios.get("/api/popup");
      if (res.data && res.data[0]) {
        setParagraph(res.data[0].paragraph || "");
        setImage(res.data[0].imageUrl);  // Set the image URL
        setImageName(res.data[0].imageUrl.split('/').pop() || ""); // Extract image name from URL
        setPopupId(res.data[0]._id); // Set the _id for the popup
      }
    } catch (err) {
      console.error("Error fetching content", err);
    }
  };

  const toggleModal = () => {
    if (!open) fetchContent();
    setOpen(!open);
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);  // Store the actual file object
      setImageName(file.name); // Update image name if a file is selected
    }
  };

  // Submit the form to update the content
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object to send data in a multipart/form-data format
    const formData = new FormData();
    formData.append("paragraph", paragraph);

    if (image) {
      formData.append("img", image); // Append the file object to the form data
    }

    try {
      // Send the formData using axios POST request
      const res = await axios.post("/api/popup", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure the correct content-type header is set
        },
      });

      alert("Content updated successfully!");
      toggleModal();
    } catch (err) {
      console.error("Error saving content:", err);
      alert("Error saving content");
    }
  };

  // Handle paragraph deletion
  const deleteParagraph = async () => {
    try {
      await axios.delete(`api/popup/paragraph/${popupId}`);  // Send the popupId to delete the paragraph
      setParagraph(""); // Remove paragraph from UI
      alert("Paragraph deleted successfully!");
    } catch (err) {
      alert("Error deleting paragraph");
    }
  };

  // Handle image deletion
  const deleteImage = async () => {
    try {
      await axios.delete(`api/popup/image/${popupId}`);  // Send the popupId to delete the image
      setImage(null); // Remove image from UI
      setImageName(""); // Remove image name from UI
      alert("Image deleted successfully!");
    } catch (err) {
      alert("Error deleting image");
    }
  };

  return (
    <div className="modalDiv">
      <button onClick={toggleModal}>Edit Popup</button>

      <Popup
        open={open}
        closeOnDocumentClick={false}
        contentStyle={{ padding: "20px", width: "600px", height: "70vh", overflow: "scroll" }}
      >
        <a className="close" onClick={toggleModal}>
          &times;
        </a>
        <h3>Edit Page Content</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "10px" }}>
            {/* Displaying paragraph with proper spacing */}
            <textarea
              value={paragraph || ""}  // Use value instead of text
              onChange={(e) => setParagraph(e.target.value)}
              placeholder="Paragraph"
              rows={5}  // Increased the height of the textarea
              style={{
                width: "100%",
                height: "30vh",
                whiteSpace: "pre-line",  // This will respect the line breaks in the paragraph
              }}
            />
          </div>

          <div style={{ marginBottom: "10px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>

          {paragraph && (
            <div>
              <button type="button" onClick={deleteParagraph} style={{ marginTop: "10px" }}>
                Delete Paragraph
              </button>
            </div>
          )}

          {image && (
            <div>
              <p><strong>Image: {imageName}</strong></p> {/* Display image name */}
              <img
                src={image}  // Using the image URL (either from state or the API)
                alt="Popup"
                style={{
                  width: "100%",
                  height: "auto",
                  marginTop: "20px",
                  objectFit: "contain",  // Make sure the image is responsive
                  maxHeight: "70vh",     // Limit the image height
                }}
              />
              <button type="button" onClick={deleteImage} style={{ marginTop: "10px" }}>
                Delete Image
              </button>
            </div>
          )}

          <br /><br />
          <button type="submit">Save</button>
        </form>
      </Popup>
    </div>
  );
}

export default PopupModal;
